import Vue from 'vue'
import Router from 'vue-router'
import Earth3D from '@/components/Earth3D'
import Piling from '@/components/animation/piling'
import allPilingthree from '@/components/animation/allPilingthree'
import AllPiling from '@/components/animation/allPiling'
import DynamicRoamLine from '@/components/helmet/dynamicRoamLine'
import test from '@/components/test'
import suidao from '@/components/suidao'
import maodin from '@/components/maodin'
import dam from '@/components/dam'
import helmet from '@/components/helmet'
import ytj from '@/components/ytj'
import allPilingZL from '@/components/Earth3DZL'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Earth3D',
      component: Earth3D
    },
    {
      path: '/allPilingZL',
      name: 'allPilingZL',
      component: allPilingZL
    },
    {
      path: '/ytj',
      name: 'ytj',
      component: ytj
    },
    {
      path: '/animation/piling',
      name: 'piling',
      component: Piling
    },
    {
      path: '/animation/allPilingthree',
      name: 'allPilingthree',
      component: allPilingthree
    },
    {
      path: '/animation/allPiling',
      name: 'allPiling',
      component: AllPiling
    }, {
      path: '/test',
      name: 'test',
      component: test
    }, {
      path: '/suidao',
      name: 'suidao',
      component: suidao
    }, {
      path: '/maodin',
      name: 'maodin',
      component: maodin
    }, {
      path: '/dam',
      name: 'dam',
      component: dam
    }, {
      path: '/helmet',
      name: 'helmet',
      component: helmet
    },
    {
      path: '/helmet/dynamicRoamLine',
      name: 'dynamicRoamLine',
      component: DynamicRoamLine
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js